<template>
    <BModal :model-value="modal" centered @update:modelValue="updateModal" scrollable no-close-on-backdrop>
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Transportation</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <!-- Apply to All Days Checkbox - Show only on Day 1 -->
            <BRow v-if="props.totalDays > 1 && props.action === 'add' && props.currentDayIndex === 0 && false" class="mb-3">
                <BCol>
                    <div class="alert alert-info mb-0">
                        <BFormCheckbox v-model="applyToAllDays">
                            <strong>Apply this transportation to all {{ props.totalDays }} days</strong>
                            <br>
                            <small class="text-muted text-white">{{ daysPreview }}</small>
                        </BFormCheckbox>
                    </div>
                </BCol>
            </BRow>
            
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Transportation"
                        label-for="transportation"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="selectedTransportation"
                            label="name"
                            :get-option-label="(item) => `${item.name} (${item.pax} pax)`"
                            :options="transportationFilteredList"
                            :searchable="true"
                            :clearable="true"
                            placeholder="Select Transportation"
                            :loading="isTransportationLoading"
                            @open="getAllTransportation"
                            @option:selecting="getAllVehicle"
                        />
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Vehicle *"
                        label-for="vehicle"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="form.vehicle"
                            label="name"
                            :options="vehicleList"
                            :searchable="true"
                            :clearable="true"
                            placeholder="Select Vehicle"
                            :loading="isVehicleLoading"
                            @open="getAllVehicle"
                            :class="{
                                'is-invalid':
                                    v$.form.vehicle.$dirty &&
                                    v$.form.vehicle.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.vehicle.$dirty &&
                                v$.form.vehicle.$invalid
                            "
                        >
                            {{ v$.form.vehicle.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Name *"
                        label-for="name"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.name"
                            type="text"
                            id="name"
                            placeholder="Enter Name"
                            :class="{
                                'is-invalid':
                                    v$.form.name.$dirty && v$.form.name.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="v$.form.name.$dirty && v$.form.name.$invalid"
                        >
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                
                <BCol>
                    <BFormGroup
                        label="Pax *"
                        label-for="pax"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.pax"
                            type="number"
                            id="pax"
                            @update:modelValue="calculateSubtotal"
                            placeholder="Enter Pax"
                            :class="{
                                'is-invalid':
                                    v$.form.pax.$dirty && v$.form.pax.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="v$.form.pax.$dirty && v$.form.pax.$invalid"
                        >
                            {{ v$.form.pax.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Price Per Pax *"
                        label-for="price"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.price"
                            type="number"
                            id="price"
                            @update:modelValue="calculateSubtotal"
                            placeholder="Enter Price Per Pax"
                            :class="{
                                'is-invalid':
                                    v$.form.price.$dirty &&
                                    v$.form.price.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.price.$dirty && v$.form.price.$invalid
                            "
                        >
                            {{ v$.form.price.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Subtotal *"
                        label-for="sub_total"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.sub_total"
                            type="number"
                            id="sub_total"
                            @update:modelValue="calculatePrice"
                            placeholder="Enter Subtotal"
                            :class="{
                                'is-invalid':
                                    v$.form.sub_total.$dirty &&
                                    v$.form.sub_total.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.sub_total.$dirty && v$.form.sub_total.$invalid
                            "
                        >
                            {{ v$.form.sub_total.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Inclusion"
                        label-for="inclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.inclusion"
                            id="inclusion"
                            placeholder="Enter Inclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.inclusion.$dirty && v$.form.inclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="v$.form.inclusion.$dirty && v$.form.inclusion.$invalid"
                        >
                            {{ v$.form.inclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Exclusion"
                        label-for="exclusion"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.exclusion"
                            id="exclusion"
                            placeholder="Enter Exclusion"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.exclusion.$dirty && v$.form.exclusion.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="v$.form.exclusion.$dirty && v$.form.exclusion.$invalid"
                        >
                            {{ v$.form.exclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref, computed } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormTextarea,
    BFormCheckbox,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minValue, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
    defaultPax: Number,
    totalDays: Number,
    currentDayIndex: Number,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    selectedTransportation.value = null;
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

let selectedTransportation = ref(null);
const formData = {
    uuid: "",
    name: "",
    pax: "",
    vehicle: "",
    vehicle_uuid: "",
    price: "",
    sub_total: "",
    inclusion: "",
    exclusion: "",
};

// Apply to all days checkbox
const applyToAllDays = ref(false);

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        if (newData && Object.keys(newData).length > 0) {
            const transportationData = {
                ...newData,
                vehicle_uuid: newData.vehicle?.uuid || null,
            };
            Object.assign(form, { ...transportationData });
        } else {
            Object.assign(form, { ...formData, pax: props.defaultPax || 1 });
        }
    },
    { immediate: true }
);

// Watch for defaultPax changes from parent
watch(
    () => props.defaultPax,
    (newPax) => {
        // Only update if not editing existing data and pax is different
        if ((!props.selectedData || Object.keys(props.selectedData).length === 0) && newPax) {
            form.pax = newPax;
        }
    }
);

const rules = {
    form: {
        vehicle: {
            required: helpers.withMessage("Vehicle is required", required),
        },
        vehicle_uuid: {
            required: helpers.withMessage("Vehicle is required", required),
        },
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3 characters",
                minLength(3)
            ),
        },
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        price: {
            required: helpers.withMessage("Price is required", required),
            minValue: helpers.withMessage(
                "Price must be at least 1",
                minValue(1)
            ),
        },
        sub_total: {
            required: helpers.withMessage("Subtotal is required", required),
            minValue: helpers.withMessage(
                "Subtotal must be at least 1",
                minValue(1)
            ),
        },
        inclusion: {},
        exclusion: {},
    },
};

const v$ = useVuelidate(rules, { form });

// Computed property for days preview
const daysPreview = computed(() => {
    if (!props.totalDays || props.totalDays <= 1) return '';
    const days = Array.from({ length: props.totalDays }, (_, i) => `Day ${i + 1}`);
    if (days.length === 2) {
        return `Will be added to ${days.join(' and ')}`;
    }
    const lastDay = days.pop();
    return `Will be added to ${days.join(', ')}, and ${lastDay}`;
});

const handleAction = () => {
    props.selectedData.index != undefined ? update() : create();
};

const create = async () => {
    toast.clear();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            // Jka ada index hapus, index hanya jika edit
            const payload = { ...form, applyToAllDays: applyToAllDays.value };
            delete payload.index;
            emit("addOrUpdate", payload);
            toast.success("Transportation added successfully");
            updateModal(false);
            resetForm();
            applyToAllDays.value = false; // Reset checkbox
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    toast.clear();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            emit("addOrUpdate", {
                index: props.selectedData.index,
                ...form,
            });
            toast.success("Transportation updated successfully");
            updateModal(false);
            resetForm();
        } finally {
            loader.hide();
        }
    }
};

let transportationList = ref([]);
let isTransportationLoading = ref(false);

const getAllTransportation = async () => {
    if (transportationList.value.length > 0) return;
    isTransportationLoading.value = true;
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/transportation`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            transportationList.value = res.data;
        }
    } finally {
        isTransportationLoading.value = false;
    }
};

const transportationFilteredList = computed(() => {
    if (!form.pax) return transportationList.value;
    return transportationList.value.filter(
        (item) => item.pax == form.pax
    );
});

let vehicleList = ref([]);
let isVehicleLoading = ref(false);

const getAllVehicle = async () => {
    if(vehicleList.value.length > 0) return;
    isVehicleLoading.value = true;
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/vehicle`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            vehicleList.value = res.data;
        }
    } finally {
        isVehicleLoading.value = false;
    }
};

watch(selectedTransportation, (val) => {
    if (val) {
        form.name = val?.name;
        form.pax = val?.pax;
        form.price = val?.price;
        form.sub_total = val?.sub_total;
        form.vehicle_uuid = val?.vehicle?.uuid;
        form.vehicle = val?.vehicle;
        form.inclusion = val?.inclusion;
        form.exclusion = val?.exclusion;
    } else {
        form.name = null;
        form.pax = null;
        form.price = null;
        form.sub_total = null;
        form.vehicle_uuid = null;
        form.vehicle = null;
        form.inclusion = val?.inclusion;
        form.exclusion = val?.exclusion;
    }
});

watch(
    () => form.vehicle,
    (val) => {
        form.vehicle_uuid = val ? val.uuid : null;
    }
);

const calculateSubtotal = () => {
    if (form.pax && form.price) {
        form.sub_total = form.pax * form.price;
    } else {
        if (!form.pax || !form.price) {
            form.sub_total = 0;
        }
    }
};

const calculatePrice = () => {
    if (form.pax && form.pax != 0 && form.sub_total) {
        form.price = Math.round(form.sub_total / form.pax);
    } else if (form.pax == 0 && form.sub_total) {
        // can't divide by zero
    } else {
        if (!form.sub_total) {
            form.price = 0;
        }
    }
};

</script>
